import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sign-in-step-about',
  templateUrl: './sign-in-step-about.component.html',
  styleUrls: ['./sign-in-step-about.component.scss'],
})
export class SignInStepAboutComponent implements OnInit, OnDestroy {
  @Input() registerForm!: FormGroup;
  @Input() userTypes: Array<any> = [];
  @Input() userTypeSelected: any = null;
  @Input() isSeller = false;

  @Output() selectType = new EventEmitter<any>();
  @Output() onRegisterTypeChange = new EventEmitter<void>();
  @Output() goToStep = new EventEmitter<number>();
  @Output() submit = new EventEmitter<void>();

  private statusChangesSub: ReturnType<FormGroup['statusChanges']['subscribe']> | undefined;

  constructor(
    public translateService: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {}

  /** Tipo de usuario, teléfono/país, aceptación legal y empresa (si aplica). */
  get canContinue(): boolean {
    if (!this.registerForm) return false;
    if (this.userTypeSelected == null) return false;
    const codeOk = this.registerForm.get('code_country')?.valid ?? false;
    const phoneOk = this.registerForm.get('phone')?.valid ?? false;
    if (this.registerForm.get('factory')?.value === true) {
      const companyOk = this.registerForm.get('company_name')?.valid ?? false;
      return codeOk && phoneOk && companyOk;
    }
    return codeOk && phoneOk;
  }

  ngOnInit(): void {
    if (this.registerForm) {
      this.statusChangesSub = this.registerForm.statusChanges.subscribe(() => {
        this.cdr.markForCheck();
      });
    }
  }

  ngOnDestroy(): void {
    this.statusChangesSub?.unsubscribe();
  }
}
